export function generateCookieCSS(): string {
  return `
/* ============================================
   COOKIE BANNER
   ============================================ */

.cookie-banner {
  position: fixed;
  bottom: var(--sp-6);
  left: var(--sp-6);
  right: var(--sp-6);
  max-width: 540px;
  padding: var(--sp-6);
  background: var(--c-bg);
  border: 1px solid var(--c-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xl);
  z-index: 1000;
  overflow: hidden;
  animation: cookieSlideUp 0.4s ease-out 0.5s both;
}
@keyframes cookieSlideUp {
  from { opacity: 0; transform: translateY(100%); }
  to { opacity: 1; transform: translateY(0); }
}
.cookie-banner.hidden { display: none; }

.cookie-banner h4 {
  font-size: var(--text-lg);
  font-weight: 600;
  margin-bottom: var(--sp-2);
}
.cookie-banner p {
  font-size: var(--text-sm);
  color: var(--c-text-light);
  margin-bottom: var(--sp-5);
}
.cookie-banner p a {
  color: var(--c-primary);
  text-decoration: underline;
}

.cookie-banner__actions {
  display: flex;
  gap: var(--sp-3);
}
.cookie-banner__actions button {
  flex: 1;
  padding: var(--sp-3) var(--sp-4);
  min-height: 44px; /* Touch Target */
  font-size: var(--text-sm);
  font-weight: 500;
  border-radius: var(--btn-radius, var(--radius-md));
  cursor: pointer;
  transition: all 0.2s ease;
}
.cookie-banner__necessary {
  background: var(--c-bg-alt);
  border: 1px solid var(--c-border);
  color: var(--c-text);
}
.cookie-banner__necessary:hover { border-color: var(--c-text); }
.cookie-banner__all {
  background: var(--c-primary);
  border: 1px solid var(--c-primary);
  color: var(--c-on-primary, var(--c-white)); /* QA: A-3 */
}
.cookie-banner__all:hover { background: var(--c-primary-light); }

/* ============================================
   COOKIE PREFERENCES (Swiss-grade)
   ============================================ */

.cookie-banner__actions{
  display:flex;
  gap: var(--sp-3);
  flex-wrap: wrap;
}
.cookie-banner__actions button{
  flex: 1 1 auto;
  min-width: 120px;
  max-width: 100%;
  white-space: nowrap;
}

.cookie-banner__reject{
  background: transparent;
  border: 1px solid var(--c-border);
  color: var(--c-text);
}
.cookie-banner__reject:hover{ border-color: var(--c-text); }

.cookie-banner__settings{
  background: var(--c-bg-alt);
  border: 1px solid var(--c-border);
  color: var(--c-text);
}
.cookie-banner__settings:hover{ border-color: var(--c-text); }

/* Cookie Banner Mobile Fix */
@media (max-width: 640px) {
  .cookie-banner {
    left: var(--sp-3);
    right: var(--sp-3);
    bottom: var(--sp-3);
    padding: var(--sp-4);
    max-width: none;
  }
  .cookie-banner__actions {
    flex-direction: column;
  }
  .cookie-banner__actions button {
    width: 100%;
    min-width: unset;
  }
}

.cookie-modal{
  position: fixed;
  inset: 0;
  display: none;
  align-items: center;
  justify-content: center;
  padding: var(--sp-6);
  background: rgba(0,0,0,.55);
  z-index: 1100;
}
.cookie-modal.is-open{ display:flex; }

.cookie-modal__panel{
  width: min(560px, 100%);
  background: var(--c-bg);
  border: 1px solid var(--c-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xl);
  padding: var(--sp-7);
}

.cookie-modal__header{
  display:flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--sp-4);
  margin-bottom: var(--sp-5);
}
.cookie-modal__header h4{ margin:0; }
.cookie-modal__close{
  appearance:none;
  border:1px solid var(--c-border);
  background: transparent;
  color: var(--c-text);
  border-radius: var(--radius-md);
  width: 38px;
  height: 38px;
  cursor:pointer;
}
.cookie-modal__close:hover{ border-color: var(--c-text); }

.cookie-prefs{
  display:flex;
  flex-direction: column;
  gap: var(--sp-4);
  margin: var(--sp-5) 0;
}
.cookie-pref{
  display:flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
  padding: var(--sp-4);
  border: 1px solid var(--c-border);
  border-radius: var(--radius-md);
  background: var(--c-bg-alt);
}
.cookie-pref__meta{ min-width:0; }
.cookie-pref__meta strong{ display:block; }
.cookie-pref__meta span{ display:block; color: var(--c-text-muted); font-size: var(--text-sm); margin-top: 4px; }

.cookie-toggle{
  display:flex;
  align-items:center;
  gap: 10px;
  user-select:none;
}
.cookie-toggle input{ width: 18px; height: 18px; }

.cookie-modal__actions{
  display:flex;
  gap: var(--sp-3);
  margin-top: var(--sp-5);
}
.cookie-modal__actions .btn{ flex:1; }

.cookie-manage-link{
  text-decoration: underline;
  cursor:pointer;
}
`;
}
